// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1zOhY","inputWrap":"styles_inputWrap__2aAtU","input":"styles_input__4AoiO"};